import React from 'react';
import "./education.css";
import {FiBook} from 'react-icons/fi';


const Education = () => {
  return (
    <section id='education'>
    <br/>
    <h2>My Education</h2>

    <div className='container education_container'>
    <div>
        <article className='education_details'>
        <FiBook className='education_details-icon'/>
        <div>
        <h4>Robertson College, Winnipeg MB</h4>
        <small>Diploma, Full Stack Web Developer</small><p></p>
        <small>July 2021 - April 2022</small>
        </div>
        </article><br/> 
        <article className='education_details'>
        <FiBook className='education_details-icon'/>
        <div>
        <h4>AMA Computer College, Philippines</h4>
        <small>Bachelor of Science in Information Technology</small><p></p>
        <small>June 2006 - March 2009, undergraduate</small>
        </div>
        </article>
      </div>
      </div>
  </section>
)
}


export default Education